import React from "react";
import PrefTable from "./PrefTable";
import _ from 'lodash';
import CreateTableRows from "./CreateTableRows";
import TablePaginationHelper from "../../../utils/tablePaginationHelper";

class LoanPrefTable extends React.Component {
  state = {
    orderDir: "asc",
    orderBy: "createdAt",
    selected: []
  };

  tablePaginationHelper = new TablePaginationHelper(this.props.tableConfigItemId, 10);

  static defaultProps = {
    shouldHideExport: false
  }
  callbacks = {
    'expired': () => {
      this.props.setExpired(true)
    },
    'refreshGrid': () => {      
      this.props.getData(this.tablePaginationHelper.page, this.tablePaginationHelper.rowsPerPage, {
        orderDir: this.state.orderDir,
        orderBy: this.state.orderBy
      });
      this.props.setExpired(true); 
    },
    getDealId: () => this.props.dealId
  }
  componentDidUpdate(prevProps, prevState){
    const page = this.tablePaginationHelper.page;
    const rowsPerPage = this.tablePaginationHelper.rowsPerPage;
    const { orderDir, orderBy } = this.state;
    const {screenPreferences,isExpired} = this.props;    
    if(isExpired && screenPreferences && screenPreferences.length > 0){
      this.props.getData( page, rowsPerPage, {orderDir, orderBy});
      this.props.setExpired(false);    
    }
    else if ( this.shouldUpdate(prevProps, prevState)){
      this.props.getData( page, rowsPerPage, {orderDir, orderBy});      
    }
  }
  shouldUpdate = (prevProps, prevState) => {
    const page = this.tablePaginationHelper.page;
    const rowsPerPage = this.tablePaginationHelper.rowsPerPage;
    const { orderDir, orderBy } = this.state;
    const {page: prevPage, rowsPerPage: prevRowsPerPage, orderDir: prevOrderDir, orderBy: prevOrderBy} = prevState;    
    const {screenPreferences} = this.props;
    const {screenPreferences: prevScreenPreferences,} = prevProps;
    
    return (prevPage && page !== prevPage) || 
          (prevRowsPerPage && rowsPerPage !== prevRowsPerPage) || 
          orderDir !== prevOrderDir || 
          orderBy !== prevOrderBy || 
          screenPreferences !== prevScreenPreferences;
  }
  // BEGIN: Table Controls
  handleRequestSort = (event, property) => {
    const orderBy = property.dataField;
    let order = "desc";
    if (orderBy) {
      if (
        this.state.orderBy === property.dataField &&
        this.state.orderDir === "desc"
      ) {
        order = "asc";
      }

      this.tablePaginationHelper.page = 0;
      this.setState({ orderDir: order.toLowerCase(), orderBy });
    }
  };

  handleChangePage = (event, newPage) => {
    if (event) {
      this.tablePaginationHelper.page = newPage;
    }
  };

  handleChangeRowsPerPage = event => {
    this.tablePaginationHelper.rowsPerPage = event.target.value;
    this.forceUpdate();
  }

  render() {    
    const { screenPreferences, shouldHideConfig, shouldHideExport, dealId,callbacks } = this.props;
    if(_.isEmpty(screenPreferences))
      return null;
    if(_.isEmpty(this.props.tableData))
      return null;    
    const tableSettings = {
      tableData: this.props.tableData,
      dataMap: data => data.loans,
      getCount: tableData => tableData.data.count,
      orderDir: this.state.orderDir,
      orderBy: this.state.orderBy,
      selected: this.state.selected,
      rowsPerPage: this.tablePaginationHelper.rowsPerPage,
      page: this.tablePaginationHelper.page
    };
    //required from client code:
    // screenPreferences
    // screenType
    // tableScreenElements
    return (
      <PrefTable   
        shouldHidePageControls = {this.props.shouldHidePageControls}
        shouldHideOptionsMenu = {this.props.shouldHideOptionsMenu}   
        shouldHideConfig={shouldHideConfig}
        shouldHideExport={shouldHideExport}
        tableClasses = ""
        tableSettings={tableSettings}
        screenPreferences={screenPreferences}
        screenType={this.props.screenType}
        tableLabel={this.props.tableLabel}
        handleRequestSort={this.handleRequestSort}
        handleChangePage={this.handleChangePage}
        handleChangeRowsPerPage={this.handleChangeRowsPerPage}
        TableScreenElements={this.props.tableScreenElements}
        getRows={CreateTableRows}
        callbacks={this.callbacks}
        dealId={dealId}
        exportTable={this.props.downloadLoans}
      />
    );
  }
}

export default LoanPrefTable;
